export default __webpack_public_path__ + "01b04635743ebef7b4c74a3432b773e9.png";